import { createApp } from "vue";
import App from './App.vue';
import { BootstrapVue3 } from 'bootstrap-vue-3';
import { createI18n } from 'vue-i18n';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import en from './locales/en.json';
import fr from './locales/fr.json';
import router from './router';
import store from './store';
const isFrench = window.location.host === process.env.VUE_APP_FRENCH_HOST;
const i18n = createI18n({
  locale: isFrench ? 'fr' : 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
  },
});

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(BootstrapVue3);
app.mount('#app');